// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1qlPH","question":"Question_question__cz8CS","description":"Question_description__cWfkm"};